<script setup lang="ts">
import type { Component } from 'vue';
import { BIcon } from '../base';

type PropsType = {
    icon: string;
    iconComponent?: Component;
    iconComponentWidth?: number;
    iconComponentHeight?: number;
    iconComponentColor?: string;
};
const props = withDefaults(defineProps<PropsType>(), {
    iconComponentWidth: 20,
    iconComponentHeight: 20,
    iconComponentColor: 'rgb(var(--v-theme-grey-800))',
});
</script>

<template>
    <component
        v-if="props.iconComponent"
        :is="props.iconComponent"
        :width="props.iconComponentWidth"
        :height="props.iconComponentHeight"
        :style="{ color: props.iconComponentColor }"
    />
    <BIcon
        v-else
        size="small"
        color="grey-800"
    >{{ props.icon }}</BIcon
    >
</template>
